import template from './cameraControlsOverlay.html';

/* @ngInject */
function CamOverlayController($scope, $element, growl, PTZControlsService, CameraService) {
  const vm = this;
  // /////////////// //
  // local variables //
  // /////////////// //
  const ZOOM_INCREMENT = 0.01;
  const ZOOMS_BACKUP = {};
  let cameras = null;

  // 'down' is a boolean that is true if used by keyDown function and false otherwise
  const keyEvents = {
    37: (down) => {
      vm.controlsClasses.forcedHover.left = down;
      return 'left';
    },
    38: (down) => {
      vm.controlsClasses.forcedHover.up = down;
      return 'up';
    },
    39: (down) => {
      vm.controlsClasses.forcedHover.right = down;
      return 'right';
    },
    40: (down) => {
      vm.controlsClasses.forcedHover.down = down;
      return 'down';
    }
  };

  // //////////////// //
  // public variables //
  // //////////////// //
  vm.savingZoom = false;
  vm.isAutoFocusing = false;
  vm.zooms = {};
  vm.controlsClasses = {
    zoomButtonActive: false,
    forcedHover: {
      up: false,
      right: false,
      down: false,
      left: false
    }
  };

  // ///////////////// //
  // public functions  //
  // ///////////////// //
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.keyDown = keyDown;
  vm.keyUp = keyUp;
  vm.moveInDirection = moveInDirection;
  vm.autoFocus = autoFocus;
  vm.setZoom = setZoom;
  vm.activateZoom = activateZoom;
  vm.setZoomClickIn = setZoomClickIn;
  vm.setZoomClickOut = setZoomClickOut;
  vm.handleNewEvent = handleNewEvent;
  // vm.handleStopVideo = handleStopVideo;

  function init() {
    $element.focus();
    cameras = CameraService.getCamerasForPanel(vm.panel.id);
    vm.cameras = cameras;
    if (cameras) {
      _.forEach(cameras, (camera) => {
        getZoom(camera.id);
      });
    }
  }

  function postLink() {
    // listen for 'zoom' events for the cameras on this panel and update model
    _.forEach(vm.panel.equipment, (cameraId) => {
      $scope.$on(`event:${cameraId}`, vm.handleNewEvent);
    });
  }

  function keyUp(event) {
    if (_.has(keyEvents, event.keyCode)) {
      keyEvents[event.keyCode]();
    }
  }

  function keyDown(event) {
    let direction = null;
    if (_.has(keyEvents, event.keyCode)) {
      direction = keyEvents[event.keyCode](true);
    }

    if (direction) {
      // if PTZ Controls Overlay has focus, and keyDown function was triggered
      // by an arrow key, prevent browser from 'scrolling' dashboard (default action for arrow keys)
      event.preventDefault();
      moveInDirection(event, direction);
    }
  }

  function moveInDirection(event, direction) {
    event.stopPropagation();
    const sendSelectedStream = CameraService.hasMultiViews(vm.panel.id, vm.currentCamera) ?
      vm.selectedStream :
      undefined;
    PTZControlsService.moveInDirection(vm.currentCamera, direction, sendSelectedStream)
      .catch((res) => {
        growl.error(res.error, {
          title: `Error moving camera ${direction}`
        });
      });
  }

  function autoFocus() {
    vm.isAutoFocusing = true;
    let growlMessage = growl.info('Auto-focusing camera...', {
      disableCloseButton: true
    });
    CameraService.autoFocus(vm.currentCamera)
      .then(() => {
        vm.isAutoFocusing = false;
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.success('Camera has been auto-focused!');
      })
      .catch((res) => {
        vm.isAutoFocusing = false;
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.error(res.error, {
          title: 'Error auto-focusing camera:'
        });
      });
  }

  function setZoom() {
    vm.savingZoom = true;
    let growlMessage = growl.info('Setting zoom...', {
      disableCloseButton: true
    });
      // store locally incase user switches the active camera before the promise resolves
    const camId = vm.currentCamera;
    const sendSelectedStream = CameraService.hasMultiViews(vm.panel.id, camId) ? vm.selectedStream : undefined;
    CameraService.setZoom(camId, vm.zooms[camId], sendSelectedStream)
      .then(() => {
        vm.savingZoom = false;
        if (growlMessage) {
          growlMessage.destroy();
        }
        ZOOMS_BACKUP[camId] = vm.zooms[camId];
        growlMessage = growl.success('Zoom set successfully!');
      })
      .catch((res) => {
        vm.savingZoom = false;
        if (growlMessage) {
          growlMessage.destroy();
        }
        vm.zooms[camId] = ZOOMS_BACKUP[camId];
        growlMessage = growl.error(res.error, {
          title: 'Error setting zoom:'
        });
      });
  }


  function setZoomClickIn() {
    // convert to Number for incrementing 1%
    let newZoom = parseFloat(vm.zooms[vm.currentCamera]) + ZOOM_INCREMENT;
    if (newZoom > 1) {
      // axis camera zooms range from 0 to 1
      newZoom = 1;
    }
    // zooms are sent/recieved from the camera as strings
    vm.zooms[vm.currentCamera] = newZoom.toFixed(4);
    setZoom();
  }


  function setZoomClickOut() {
    // convert to Number for decrementing 1%
    let newZoom = parseFloat(vm.zooms[vm.currentCamera]) - ZOOM_INCREMENT;
    if (newZoom < 0) {
      // axis camera zooms range from 0 to 1
      newZoom = 0;
    }
    // zooms are sent/recieved from the camera as strings
    vm.zooms[vm.currentCamera] = newZoom.toFixed(4);
    setZoom();
  }

  function getZoom(cameraId) {
    const sendSelectedStream = CameraService.hasMultiViews(vm.panel.id, vm.currentCamera) ?
      vm.selectedStream :
      undefined;
    CameraService.getZoom(cameraId, sendSelectedStream)
      .then((response) => {
        vm.zooms[cameraId] = response.data.zoom;
        ZOOMS_BACKUP[cameraId] = response.data.zoom;
      });
  }

  function activateZoom(event) {
    event.stopPropagation();
    vm.controlsClasses.zoomButtonActive = !vm.controlsClasses.zoomButtonActive;
  }

  function handleNewEvent(__, eventObj) {
    if ((eventObj.eventName === 'cameras/cameraZoomed') &&
      _.has(eventObj, ['data', 'zoom']) &&
      _.has(vm.zooms, eventObj.equipment.id)) {
      vm.zooms[eventObj.equipment.id] = eventObj.data.zoom;
      ZOOMS_BACKUP[eventObj.equipment.id] = eventObj.data.zoom;
    }
  }
}

export default {
  name: 'cameraControlsOverlay',
  template,
  controller: CamOverlayController,
  controllerAs: 'CamOverlayCtrl',
  bindings: {
    currentCamera: '<',
    panel: '<',
    overlayCtrls: '<?', // TODO: is this really used?
    selectedStream: '<'
  }
};
